import React from "react";
import Footer from "../home/Footer";
import Header from "../../views/Header";

const ShippingPolicy = () => {
  return (
    <div>
      {/* <Header/> */}
      <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-black text-center mt-8 md:mt-12 mb-8 text-4xl font-bold font-Cinzel">
            Shipping Policy
          </h1>
          <div className="bg-white shadow-md rounded-lg overflow-hidden">
            <div className="p-6 sm:p-8 space-y-6 text-gray-800 font-Outfit text-sm sm:text-md">
              <h5>• How far does Verdical ship?</h5>
              <p>
                We make every effort to enable online ordering from our website
                for every customer. Verdical does ship orders all over India.
                However, international shipping is not available at the moment.
                Therefore, customers can place their orders from diverse
                locations in India. Furthermore, all the customers can contact
                us without any hesitation for whatever reason. Moreover, do
                contact us with your PIN code to verify if Verdical delivers in
                your region or not. We’ll check if we can provide you with
                service via a local courier.
              </p>
              <p>
                Apart from that, if you are outside of India and would like to
                shop with us, please email us at info@Verdical.in, and we will
                do our best to fill your order.
              </p>
              <h5>• Is COD available where I am?</h5>
              <p>
                Verdical does not offer and support cash on delivery (COD) at
                all. Therefore, no customer can place orders for cash on
                delivery.{" "}
              </p>
              <h5>
                What is the estimated delivery time for my Verdical order?
              </h5>
              <p>
                After you place your order, it will be shipped within 24 to 48
                hours. Typically, the order takes 5-7 working days to deliver.
                Verdical does rely on its delivery partner for secure and timely
                delivery. However, there may be unforeseen delays due to factors
                beyond our control. Therefore, we try our hardest to make sure
                your order gets to you as soon as possible because we are just
                as eager for you to use our items as you are to get them!
              </p>
              <h5>• How can I view the status of my order?</h5>
              <p>
                Your order, payment, and address information will all be
                confirmed via email or message. This is based on the contact
                information that you provided us while ordering. Furthermore,
                you will receive a dispatch notification as soon as your order
                has been processed and dispatched from us. Along with the
                carrier and tracking details, this will also contain a link to
                the courier’s website, which will show the anticipated delivery
                date for your order. If any of the following applies, we’ll try
                to get in touch with you by phone or email:{" "}
              </p>
              <ul>
                <li>
                  granting permission for such information to be collected,
                  stored, used, disclosed, processed, and transferred (in India
                  or outside);
                </li>
                <li>
                  Declare that you only have the legal authority to do so or
                  that you have obtained the required consents from the
                  individuals whose information you have shared with us for the
                  purposes set forth in this Policy;{" "}
                </li>
                <li>
                  nd that you provided the information voluntarily and free from
                  compulsion.
                </li>
              </ul>
              <br />
              <br />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ShippingPolicy;
